import React from 'react';
import { CustomStepProps } from '../../types/survey';
import { Button } from '../ui/Button';

/**
 * Simple Physical Activity Introduction Slide
 */
export const PhysicalActivityIntroSlide: React.FC<CustomStepProps> = ({
  onNext,
  onBack,
  currentStep,
  totalSteps
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-royal-blue-lightest via-white to-royal-gold-lightest flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-xl p-12">
          {/* Main Content */}
          <div className="text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Physical Activity
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed mb-12">
              What is your standard physical activity? How able are you to keep up regular exercise? 
              Take a moment to think about this topic and then answer the following questions.
            </p>
          </div>

          {/* Progress Indicator */}
          <div className="mb-8">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-600">Progress</span>
              <span className="text-sm font-semibold text-royal-gold">
                Step {currentStep + 1} of {totalSteps}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-gradient-to-r from-royal-gold to-royal-blue h-2 rounded-full transition-all duration-300"
                style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
              />
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={onBack}
              variant="secondary"
              size="lg"
              className="w-full sm:w-auto"
            >
              Previous
            </Button>
            
            <Button
              onClick={onNext}
              variant="primary"
              size="lg"
              className="w-full sm:w-auto"
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};